/* 馬超傳・第 3 章上半：潼關（中）交馬語（建安十六年，211）
 * 史實：〈馬超傳〉「曹公與遂、超單馬會語，超負其多力，陰欲突前捉曹公，曹公左右將許褚瞋目盻之，超乃不敢動。」
 *       《許褚傳》「超負其力，陰欲前突太祖，素聞褚勇，疑從騎是褚。乃問太祖曰：『公有虎侯者安在？』太祖顧指褚，褚瞋目盼之。超不敢動，乃各罷。」
 *       《武帝紀》「於是交馬語移時，不及軍事，但說京都舊故，拊手歡笑。」
 * 流程：兩軍陣前，曹操和韓遂交馬語。馬超想趁機突前捉曹操：許褚的視線是一片扇形，被他看著就不能動；
 *       他回頭看韓遂、看曹營時才能往前挪。走動時被他看見會起疑，起疑兩次曹操就回營。
 *       照史實，最後一步一定會被許褚瞪住（劇情，不是失敗）。打完接第二幕「離間」（def.next）。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, hero } from '../kit.ts';
import { MEN, inCone, turn, angleTo, drawCone } from './machao_kit.ts';
import { TALK, XICAMP, CAOCAMP } from '../maps/machao_weinan.ts';

const LV = 12, LIMIT = 80, HALF = (32 * Math.PI) / 180, SUS_MAX = 2;
const CAO = [TALK[0] + 160, TALK[1]], XC = [TALK[0] + 230, TALK[1] - 110];
const CHAT = [['曹操', '文約！當年在京都，你我同歲舉孝廉，還記得嗎？'], ['韓遂', '記得記得——那時孟德還是個洛陽北部尉。'], ['曹操', '哈哈哈，五色棒！'], ['韓遂', '（拊手大笑）'], ['曹操', '京師舊人，如今還剩幾個？'], ['韓遂', '都老了，都老了。']];

export default {
  id: 'machao-3a', map: 'machao_weinan', hero: 'machao',
  next: 'machao-3', // 第二幕：離間（評星在第二幕）
  title: '第 3 章　潼關（中）', year: '建安十六年（211）',
  brief: {
    quote: [{ text: '曹公與遂、超單馬會語，超負其多力，陰欲突前捉曹公。', src: '《三國志·蜀書·馬超傳》' }],
    text: '曹操渡過渭水，在渭南立營。聯軍幾次挑戰不利，請求割地講和。曹操答應和韓遂在陣前單馬會語，馬超同去，打算趁機捉住曹操。曹操身邊只帶了許褚一人。',
    goals: ['趁許褚不注意，一步步靠近曹操', '（下半）離間'],
  },
  words: { ally: '關西軍', foe: '曹軍' },
  steps: [
    { // 0. 會語：一步步靠近
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = TALK[0] - 1900; me.y = TALK[1] + 60;
        V.t0 = w.t; V.sus = 0; V.seen = 0; V.chat = 0; V.chatT = 3;
        V.hs = ally(w, MEN.hansui, TALK[0] - 120, TALK[1], LV); V.hs.name = '韓遂'; V.hs.hold = [TALK[0] - 120, TALK[1]];
        V.cao = boss(w, hero('caocao'), CAO[0], CAO[1], { name: '曹操', hp: 6000, atk: 0, untargetable: true, ms: 0, caster: false, range: 0 });
        V.xc = boss(w, hero('xuchu'), XC[0], XC[1], { name: '許褚', hp: 9000, atk: 0, untargetable: true, ms: 0, caster: false, range: 0 });
        V.cone = { x: V.xc.x, y: V.xc.y, a: angleTo(V.xc, me), half: HALF, r: 1700 };
        V.phase = 'watch'; V.phaseT = 3;
        m.line('馬超', '（曹操身邊只有一個大漢……趁他們說話，衝過去捉住他。）');
        m.after(3, () => m.line('提示', '地上的扇形是許褚的視線：被他看著就動不了；走動時被他看見會起疑（兩次就失敗）。等他轉頭再往前挪。'));
        m.mark('cao', CAO[0], CAO[1], '曹操');
        m.obj('near', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, C = V.cone, left = LIMIT - (w.t - V.t0);
        m.get('near').text = `靠近曹操（許褚起疑 ${V.sus}/${SUS_MAX}；${Math.max(0, Math.ceil(left))} 秒後會語結束）`;
        // 交馬語：說京都舊故
        if ((V.chatT -= dt) <= 0 && V.chat < CHAT.length) { V.chatT = 6; m.line(...CHAT[V.chat++]); }
        // 許褚：盯著馬超幾秒，回頭看一下韓遂或曹營，再轉回來
        if ((V.phaseT -= dt) <= 0) {
          if (V.phase === 'watch') { V.phase = 'away'; V.phaseT = 2.2 + SG.rand() * 1.2; V.awayA = SG.rand() < 0.5 ? angleTo(V.xc, V.hs) - 0.9 : angleTo(V.xc, { x: CAOCAMP[0], y: CAOCAMP[1] - 600 }); }
          else { V.phase = 'watch'; V.phaseT = 2.5 + SG.rand() * 2; }
        }
        C.a = turn(C.a, V.phase === 'watch' ? angleTo(V.xc, me) : V.awayA, 2.6, dt);
        const seen = inCone(C, me);
        if (seen) {
          me.st.root = Math.max(me.st.root, 0.15); me.input.skill = null;
          if (!V.inCone) { // 剛被看見：在走動就起疑
            V.seen++;
            if (V.moving) { V.sus++; m.line('許褚', V.sus >= SUS_MAX ? '……（按刀上前一步）' : '……（瞋目盻之）'); w.dmgEvents.push({ x: me.x, y: me.y - 90, text: '被看見了', team: 1, src: V.xc.id, tgt: me.id }); }
          }
        }
        V.inCone = seen;
        V.moving = SG.gd(me.x, me.y, V.px || me.x, V.py || me.y) > 1; V.px = me.x; V.py = me.y;
        if (V.sus >= SUS_MAX) { m.lose('許褚起疑，曹操回營'); return false; }
        if (left <= 0) { m.lose('會語已畢，曹操回營'); return false; }
        return SG.gd(me.x, me.y, CAO[0], CAO[1]) < 330;
      },
    },
    { // 1. 瞋目盻之
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('near'); m.unmark('cao');
        V.phase = 'stare'; V.stareT = w.t;
        me.st.root = Math.max(me.st.root, 0.2); me.input.moveTo = null;
        m.big('許褚瞋目盻之！');
        m.card('超負其多力，陰欲突前捉曹公，曹公左右將許褚瞋目盻之，超乃不敢動。', '〈馬超傳〉');
        m.line('馬超', '公有虎侯者安在？');
        m.after(2.5, () => m.line('曹操', '（回頭指了指許褚）'));
        m.after(7, () => m.card('交馬語移時，不及軍事，但說京都舊故，拊手歡笑。', '《武帝紀》'));
        m.after(11, () => m.win());
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        V.cone.a = turn(V.cone.a, angleTo(V.xc, me), 4, dt);
        me.st.root = Math.max(me.st.root, 0.2); me.input.skill = null; me.input.moveTo = null; me.input.target = null;
        return false;
      },
    },
  ],
  always(m, w) {
    if (!w.player.alive) { m.lose('馬超陣亡'); return; }
    if (m.vars.hs) allyTick(w, m.vars.hs, null, 0);
  },
  ground(ctx, m) {
    const C = m.vars.cone;
    if (C) drawCone(ctx, C, m.vars.phase === 'stare' ? '#e04030' : '#f0c040', m.vars.phase === 'away' ? 0.1 : 0.2);
  },
};
